import { noClmStatus, clmAmtStatus, isDrvStatus, drvExpStatus, drvAgeStatus, vehRegYrStatus } from '@/components/agency/motor/quotation/permStatus'
import { yearDiff } from '@/utils/date'
import toDate from 'date-fns/toDate'

export const motor = {
  mtrQuotePermitStatus: (state) => {
    let result = {
      permitStatus: 'A',
      referredList: [],
      declineList: []
    }

    // Check No. of Claim
    if (state.quotation.motorForm.noClm !== null) {
      result = compileMtrQuotePermitStatus(result, noClmStatus(state.quotation.motorForm.noClm), 'No. of Claims')
    }

    // Check Claim Amt
    if (state.quotation.motorForm.clmAmt !== null) {
      result = compileMtrQuotePermitStatus(result, clmAmtStatus(state.quotation.motorForm.clmAmt), 'Total Claim Amount')
    }

    if (state.quotation.motorForm.drivers && state.quotation.motorForm.drivers.length > 0) {
      const mainDriver = state.quotation.motorForm.drivers[0]
      // Check Driver's exp
      result = compileMtrQuotePermitStatus(result, drvExpStatus(mainDriver.drvExp), 'Driving Experience')

      // Check Driver's age
      const drvAge = yearDiff(state.quotation.commonForm.startDate, mainDriver.drvDob)
      result = compileMtrQuotePermitStatus(result, drvAgeStatus(drvAge), "Main Driver's Age")
    }

    // Check Veh Reg Yr
    if (state.quotation.motorForm.vehRegYr !== null) {
      const vehAge = toDate(state.quotation.commonForm.startDate).getFullYear() - state.quotation.motorForm.vehRegYr
      result = compileMtrQuotePermitStatus(result, vehRegYrStatus(vehAge), 'Vehicle Registration Year')
    }

    // Check Applicant is Driving
    if (state.quotation.commonForm.applicant.appIntStat) {
      if (state.quotation.commonForm.applicant.appIntStat === 'I') {
        if (state.quotation.commonForm.applicant.appIsDrv !== null) {
          result = compileMtrQuotePermitStatus(result, isDrvStatus(state.quotation.commonForm.applicant.appIsDrv), 'Applicant not driving')
        }
      }
    }

    // Check NCD Rate
    if (state.quotation.motorForm.ncdRate !== null && state.quotation.motorParam.ncdRate) {
      for (var i = 0; i < state.quotation.motorParam.ncdRate.length; i++) {
        const ncdRate = state.quotation.motorParam.ncdRate[i]
        if (state.quotation.motorForm.ncdRate === ncdRate.value) {
          result = compileMtrQuotePermitStatus(result, ncdRate.permitStatus, 'Existing NCD')
          break
        }
      }
    }

    // Check Veh model
    if (state.quotation.motorForm.vehModel !== null) {
      for (var x = 0; x < state.quotation.motorParam.vehModel.length; x++) {
        const model = state.quotation.motorParam.vehModel[x]
        if (state.quotation.motorForm.vehModel === model.value) {
          result = compileMtrQuotePermitStatus(result, model.permitStatus, 'Vehicle Model')
          break
        }
      }
    }
    // Check Veh Usg
    if (state.quotation.motorForm.vehUsg !== null) {
      for (var y = 0; y < state.quotation.motorParam.vehUsg.length; y++) {
        const usg = state.quotation.motorParam.vehUsg[y]
        if (state.quotation.motorForm.vehUsg === usg.value) {
          result = compileMtrQuotePermitStatus(result, usg.secondaryValue, 'Vehicle Usage')
          break
        }
      }
    }
    return result
  },
  mtrQuoteQueryPermitStatus: (state) => {
    let result = {
      permitStatus: 'A',
      referredList: [],
      declineList: []
    }
    const { permStatuses } = state.quotation.queryInfo
    if (permStatuses && permStatuses.length > 0) {
      for (let permStat of permStatuses) {
        if (permStat.permStatus === 'R') {
          result.referredList.push(permStat.description)
          if (result.permitStatus !== 'D') {
            result.permitStatus = 'R'
          }
        } else if (permStat.permStatus === 'D') {
          result.declineList.push(permStat.description)
          result.permitStatus = 'D'
        }
      }
    }
    return result
  }
}

function compileMtrQuotePermitStatus(result, newPermitStatus, label) {
  // Status D > R > A
  if (newPermitStatus === 'R') {
    result.referredList.push(label)
    if (result.permitStatus !== 'D') {
      result.permitStatus = 'R'
    }
  } else if (newPermitStatus === 'D') {
    result.declineList.push(label)
    result.permitStatus = 'D'
  }
  return result
}
